import { dataLoaded, dataLoading } from 'app/modules/cms/service/store/cms-actions';
import { insuredElementApi } from '../api';
import { ACTION_TYPES } from './store/insuredElement.actions';

export const getSellingPointList = () => async dispatch => {
  await dispatch(dataLoading());
  const result = await insuredElementApi.getSellingPointList();
  if (result.isFailure) {
    // globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const sellingPoints = result.getValue();
  await dispatch({
    type: ACTION_TYPES.GET_SELLING_POINTS,
    payload: {
      sellingPointList: sellingPoints
    }
  });
  await dispatch(dataLoaded());
};

export const getInsuredGoodTypeList = () => async dispatch => {
  const result = await insuredElementApi.getInsuredGoods();
  if (result.isFailure) {
    // globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }
  const insuredElement = result.getValue();
  await dispatch({
    type: ACTION_TYPES.GET_INSURED_GOOD_TYPES,
    payload: {
      insuredElementList: insuredElement
    }
  });
};

export const updateInsuredGood = (param: any) => async (dispatch, getState) => {
  const { insuredGood } = await getState()?.insuredElementData;
  await dispatch({ type: ACTION_TYPES.UPDATE_INSURED_GOOD, payload: { ...insuredGood, ...param } });
};
